import { render } from "./RelatedPostsTable.vue?vue&type=template&id=24989450&scoped=true"
import script from "./RelatedPostsTable.vue?vue&type=script&lang=js"
export * from "./RelatedPostsTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=24989450&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24989450"]])

export default __exports__